export const ERRORS = {
  ALL_FIELDS: 'Enter all fields',
  IMAGES_LENGTH: 'Select images not more then 5',
  PHONE_NUM_LENGTH_ERROR: 'Mobile number must be 10 digits',
  ZIP_CODE_LENGTH_ERROR: 'Zip code must be 5 digits',
  FORM_FAIL: 'Failed to submit form',
  FILL_ALL_ASTERISK_FIELDS: 'Fill all asterisk fields',
  POST_CODE_WRONG: 'Enter correct post code'
}
